import React, { useState, useEffect } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { getDrive, newEvent, getCandidates, editContactNotes, editContact, getContact, uploadFile } from './../API';
import { navigate } from "@reach/router"
import { Badge, Tag, BackTop, Switch, List, Tooltip, Divider, Checkbox, Radio, Empty, Avatar, Spin, Select, DatePicker, Modal, Input, Form, Tabs, Button, Icon, Upload, Card, Row, Col, Skeleton, message } from 'antd';
import CustomAvatar from './../components/customAvatar';
import { flexCenterRight, formItemLayoutForNewEvent, formItemLayout, nameStyle, roleStyle } from './../theme';
import { uploadFileValidator, readFileAsync } from './../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ContactEventsList from './../components/contactEventsList';
import { s3, EVENT_TYPE, editorConfig } from './../utils';
import parse from 'html-react-parser';
import moment from 'moment';
import InvoicesList from './../components/invoicesList';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

const { orderBy, uniqBy } = require('lodash');

const { TabPane } = Tabs;
const { Option } = Select;
const { Search } = Input;

const linkGlobalUsers = [
  {
    name: 'Lin',
    email: 'lin.lu@linkglobalrecruitment.com',
  },
  {
    name: 'Anny',
    email: 'anny.ma@linkglobalrecruitment.com',
  }
]

function ContactForm(props) {
  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const contact = useMappedState(state => state.contact);
  const contactCandidateList = useMappedState(state => state.contactCandidateList);

  const [eventReloading, setEventReloading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [avatarLoading, setAvatarLoading] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notes, setNotes] = useState(null);
  const [notesLoading, setNotesLoading] = useState(false);

  const eventsTypeArr = orderBy(Object.keys(EVENT_TYPE).map(e => {
    return EVENT_TYPE[e]
  }));

  const [eventType, setEventType] = useState(EVENT_TYPE.all.name);

  const [showCreateVacancyModal, setShowCreateVacancyModal] = useState(false);

  const [showCreateEventModal, setShowCreateEventModal] = useState(false);
  const [candidateListForNewEvent, setCandidateListForNewEvent] = useState([]);

  const [files, setFiles] = useState([]);
  const [lgFiles, setLgFiles] = useState([]);

  const reloadContact = async () => {
    setEventReloading(true);
    const response = await getContact(session.authToken, props.id);

    if (response.data.responseCode === 0) {
      setNotes(response.data.contact.notes);
      dispatch({type: "INIT_CONTACT", payload: response.data.contact});

      //re-construct all available candidates from events
      const allCandidates = uniqBy(response.data.contact.events.filter(i => i.candidate).map(x => x.candidate), 'id');
      dispatch({
        type: "SET_CONTACT_CANDIDATES_LIST",
        payload: allCandidates.map(i => {
          return {
            ...i,
            ...{avatar: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.id}.jpeg`}
          }
        })
      });
    }
    setEventReloading(false);
  }

  const NewVacancy = ({form}) => {
    const { getFieldDecorator } = form;

    const [vacancyBody, setVacancyBody] = useState(null);
    const [newVacancyLoading, setNewVacancyLoading] = useState(false);
  
    return(
      <Modal
      zIndex={100}
      centered={true}
      title="Create New Vacancy"
      closable={false}
      visible={showCreateVacancyModal}
      width="90%"
      footer={[
        <Button disabled={newVacancyLoading} key="cancel" onClick={() => {
          setShowCreateVacancyModal(false);
          setVacancyBody('');
        }}>
          <Icon type="close" />
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={async () => {
          const formResult = await form.validateFields();

          const params = {
            type: 'vacancy',
            contactID: contact.id,
            submitType: 'record',
            title: formResult.title,
            body: vacancyBody ? vacancyBody : '',
          };

          setNewVacancyLoading(true);
          const result = await newEvent(session.authToken, params);
    
          if (result.data.responseCode === 0) {
            reloadContact();
            setNewVacancyLoading(false);
            setShowCreateVacancyModal(false);
            message.success(result.data.message);
          }
          else {
            setNewVacancyLoading(false);
            message.error(result.data.message.toString());
          }
        }}>
          {newVacancyLoading ? <Icon type="loading" /> : <Icon type="check" />}
          Submit
        </Button>
      ]}
    >
      <div>
        <Row>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator('title', {
                rules: [{ required: true, message: 'Please input vacancy title!' }],
              })(
                <Input autoComplete="off" placeholder="Vacancy title" disabled={newVacancyLoading} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CKEditor
              disabled={newVacancyLoading}
              value={vacancyBody}
              data={vacancyBody}
              editor={ Editor }
              config= { editorConfig }
              onChange={ ( event, editor ) => {
                const data = editor.getData();
                setVacancyBody(data);
              }}
            />
          </Col>
        </Row>
      </div>
    </Modal>
    )
  }

  const NewVacancyForm = Form.create({ name: 'new-vacancy' })(NewVacancy);

  const NewEvent = ({form}) => {
    const { getFieldDecorator } = form;

    const [showEmailPanel, setShowEmailPanel] = useState(false);

    const [contactDocSearch, setContactDocSearch] = useState("");
    const [candidateDocSearch, setCandidateDocSearch] = useState("");

    const [contactDocList, setContactDocList] = useState([]);
    const [candidateDocList, setCandidateDocList] = useState([]);

    const [generalFiles, setGeneralFiles] = useState([]);
    const [contactFiles, setContactFiles] = useState([]);

    const [candidateFiles, setCandidateFiles] = useState([]);
    const [candidateFilesLoading, setCandidateFilesLoading] = useState(false);

    const [showContactDocs, setShowContactDocs] = useState(false);
    const [showCandidateDocs, setShowCandidateDocs] = useState(false);

    const [contactAttachment, setContactAttachment] = useState([]);
    const [candidateAttachment, setCandidateAttachment] = useState([]);

    const [eventBody, setEventBody] = useState(null);
    const [contactEmailBody, setContactEmailBody] = useState(null);
    const [candidateEmailBody, setCandidateEmailBody] = useState(null);

    const [writingPanel, setWritingPanel] = useState('record');
    const [newEventLoading, setNewEventLoading] = useState(false);

    const [candidateEmailDetail, setCandidateEmailDetail] = useState(null);

    const eventsTypesForNewEvent = eventsTypeArr.filter(
      i => i.name !== 'all' && 
      i.name !== 'interview-follow-up' &&
      i.name !== 'bulk-emails' && 
      i.name !== 'vacancy' && 
      i.name !== 'check-payment' &&
      i.name !== 'send-invoice');

    const eventTypeSelectionForNewEvent = [];
    for (let i = 0; i < eventsTypesForNewEvent.length; i++) {
      eventTypeSelectionForNewEvent.push(
        <Option key={eventsTypesForNewEvent[i].name} value={eventsTypesForNewEvent[i].name}>
          {eventsTypesForNewEvent[i].text}
        </Option>
      )
    }

    const candidateSelectionForNewEvent = [
      <Option label="Not Select" key="n/s" value="">Not Select</Option>
    ];
    for (let i = 0; i < candidateListForNewEvent.length; i++) {
      candidateSelectionForNewEvent.push(
        <Option
          label={`${candidateListForNewEvent[i].firstname} ${candidateListForNewEvent[i].lastname}`}
          key={candidateListForNewEvent[i].id}
          value={candidateListForNewEvent[i].id}>
          <CustomAvatar
            style={{marginTop: '-3px'}}
            colourCode={candidateListForNewEvent[i].firstname.charAt(0).toLowerCase()}
            char={`${candidateListForNewEvent[i].firstname.charAt(0).toUpperCase()}${candidateListForNewEvent[i].lastname.charAt(0).toUpperCase()}`}
            charSize={11}
            size={26}
            src={candidateListForNewEvent[i].avatar}
          />
          &nbsp;&nbsp;{candidateListForNewEvent[i].firstname} {candidateListForNewEvent[i].lastname}
        </Option>
    )}

    const handleOnClickSubmitNewEvent = async () => {
      const formResult = await form.validateFields();

      let params = {
        type: formResult.eventtype,
        contactID: contact.id,
      }

      if (formResult.submitType === 'record') {
        params = {...params, ...{submitType: 'record', body: eventBody ? eventBody : ""}}
        if (formResult.candidate) {
          params = {...params, ...{candidateID: formResult.candidate}}
        }
      }

      if (formResult.submitType === 'email') {

        const contactFileList = [];
        for (const each of contactAttachment) {
          const file = await readFileAsync(each)
          contactFileList.push({
            name: each.name,
            type: each.type,
            data: file.replace(/data:.+,/, ""),
          })
        }

        const contactDriveList = [];
        for (const each of contactDocList) {
          contactDriveList.push({
            id: each.id,
            name: each.name,
            type: each.mimeType,
            icon: each.iconLink
          })
        }

        params = {
          ...params,
          ...{
            submitType: 'email',
            contactEmail: formResult.contact_email,
            contactEmail1: formResult.contact_email1 ? formResult.contact_email1 : false,
            contactEmail2: formResult.contact_email2 ? formResult.contact_email2 : false,
            contactCC: formResult.contact_cc ? formResult.contact_cc : [],
            contactBCC: formResult.contact_bcc ? formResult.contact_bcc : [],
            linkGlobalCC: formResult.linkGlobal_cc ? formResult.linkGlobal_cc : [],
            linkGlobalBCC: formResult.linkGlobal_bcc ? formResult.linkGlobal_bcc : [],
            contactEmailSubject: formResult.contact_email_subject,
            contactEmailBody: contactEmailBody ? contactEmailBody : "",
            contactEmailFiles: contactFileList,
            contactEmailDrives: contactDriveList
          }
        }

        if (formResult.candidate) {

          params = {...params, ...{candidateID: formResult.candidate}}

          if (showEmailPanel) {
            const candidateFileList = [];
            for (const each of candidateAttachment) {
              const file = await readFileAsync(each)
              candidateFileList.push({
                name: each.name,
                type: each.type,
                data: file.replace(/data:.+,/, ""),
              })
            }

            const candidateDriveList = [];
            for (const each of candidateDocList) {
              candidateDriveList.push({
                id: each.id,
                name: each.name,
                type: each.mimeType,
                icon: each.iconLink
              })
            }

            params = {
              ...params,
              ...{
                candidateEmail: formResult.candidate_email,
                candidateEmail1: formResult.candidate_email1 ? formResult.candidate_email1 : false,
                candidateEmail2: formResult.candidate_email2 ? formResult.candidate_email2 : false,
                candidateEmailSubject: formResult.candidate_email_subject,
                candidateEmailBody: candidateEmailBody ? candidateEmailBody : "",
                candidateEmailFiles: candidateFileList,
                candidateEmailDrives: candidateDriveList
              }
            }
          }
          else {
            params = {
              ...params,
              ...{candidateEmailDoNotSend: true}
            }
          }
        }
      }

      setNewEventLoading(true);
      const result = await newEvent(session.authToken, params);

      if (result.data.responseCode === 0) {
        reloadContact();
        setNewEventLoading(false);
        setShowCreateEventModal(false);
        message.success(result.data.message);
      }
      else {
        setNewEventLoading(false);
        message.error(result.data.message.toString());
      }
    }

    const CandidateDriveFile = ({data}) => {
      return(
        <div style={{width: '100%', marginBottom: '8px'}}>
          <Row style={{backgroundColor: '#ECF7FA'}}>
          <Col span={23}>
          <img
            style={{
              marginLeft: "5px",
              position: "relative",
            }}
            src={data.iconLink}
            alt={data.name}
          />
          &nbsp;
          {data.name}
          </Col>
          <Col span={1}>
            <div style={flexCenterRight}>
              <Icon
                onClick={() => {
                  setCandidateDocList(candidateDocList.filter(i => i.id !== data.id))
                }}
                style={{
                  cursor: "pointer",
                  marginTop: "4px",
                  marginRight: "5px",
                  position: "relative",
                }}
                type="delete" />
            </div>
          </Col>
          </Row>
        </div>
      )
    }

    const renderCandidateEmailPanel = () => {
      return(
        <div>
        <Row>
          <Col span={10}>
            <Upload {...{
              accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
              multiple: true,
              showUploadList: true,
              onRemove: file => {
                setCandidateAttachment(candidateAttachment.filter(i => i.uid !== file.uid));
              },
              beforeUpload: (_, fileList) => {
                setCandidateAttachment([...candidateAttachment, ...fileList])
                return false;
              },
              candidateAttachment,
            }}>
              <Tooltip placement="right" title={"Allowed file: image, pdf, doc, docx, xls, xlsx, ppt, pptx"}>
                <Button disabled={newEventLoading} >
                  <FontAwesomeIcon icon={faPaperclip} />&nbsp;&nbsp;Attachments
                </Button>
              </Tooltip>
            </Upload>
            <br/>
          </Col>

          <Col span={1} />

          <Col span={10}>
            <Tooltip placement="right" title={"Allowed attachment files from Google Drive"}>
              <Button onClick={() => {
                setShowCandidateDocs(true);
              }}
                disabled={newEventLoading || candidateFilesLoading} >
                {
                  candidateFilesLoading ?
                  <Icon type={"loading"} />
                  :
                  <FontAwesomeIcon icon={faFolderOpen} />
                }
                &nbsp;&nbsp;Documents
              </Button>
            </Tooltip>
            {
              candidateDocList.length > 0 ?
              <div style={{marginTop: '8px', marginBottom: '22px'}}>
                {
                  candidateDocList.map((i, k) => (
                    <CandidateDriveFile key={k} data={i} />
                  ))
                }
              </div>
              :
              null
            }
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator('candidate_email_subject', {
                rules: [{ required: true, message: 'Please input subject!' }],
              })(
                <Input autoComplete="off" placeholder="Subject" disabled={newEventLoading} />
              )}
            </Form.Item>
          </Col>
        </Row>

        <div>
          <CKEditor
            disabled={newEventLoading}
            value={candidateEmailBody}
            data={candidateEmailBody}
            editor={ Editor }
            config= { editorConfig }
            onChange={ ( event, editor ) => {
              const data = editor.getData();
              setCandidateEmailBody(data)
            }}
          />
        </div>
        </div>
      )
    }

    const EmailCheckboxs = () => {
      return(
        <React.Fragment>
        <Divider />
        <div>To Contact: <b>{contact.firstname} {contact.lastname}</b></div>
        <Row>
          <Col span={8}>
            <Form.Item>
              {getFieldDecorator('contact_email', {
                initialValue: true,
                valuePropName: 'checked'
              })(<Checkbox disabled={true}>{contact.email}</Checkbox>)}
            </Form.Item>
          </Col>
          <Col span={8}>
          {
            contact.email1 ?
            <Form.Item>
              {getFieldDecorator('contact_email1', {
                initialValue: true,
                valuePropName: 'checked'
              })(<Checkbox>{contact.email1}</Checkbox>)}
            </Form.Item>
            :
            null
          }
          </Col>
          <Col span={8}>
            {
              contact.email2 ?
              <Form.Item>
                {getFieldDecorator('contact_email2', {
                  initialValue: true,
                  valuePropName: 'checked'
                })(<Checkbox>{contact.email2}</Checkbox>)}
              </Form.Item>
              :
              null
            }
          </Col>
        </Row>
        </React.Fragment>
      )
    }

    const CandidateEmailCheckboxs = () => {
      const c = candidateListForNewEvent.find(i => i.id === candidateEmailDetail);
      return(
        <React.Fragment>
        <Divider />
        <div>To Candidate: <b>{c.firstname} {c.lastname}</b></div>
        <Row>
          <Col span={8}>
            <Form.Item>
              {getFieldDecorator('candidate_email', {
                initialValue: true,
                valuePropName: 'checked'
              })(<Checkbox disabled={true}>{c.email}</Checkbox>)}
            </Form.Item>
          </Col>
          <Col span={8}>
          {
            c.email1 ?
            <Form.Item>
              {getFieldDecorator('candidate_email1', {
                initialValue: true,
                valuePropName: 'checked'
              })(<Checkbox>{c.email1}</Checkbox>)}
            </Form.Item>
            :
            null
          }
          </Col>
          <Col span={8}>
            {
              c.email2 ?
              <Form.Item>
                {getFieldDecorator('candidate_email2', {
                  initialValue: true,
                  valuePropName: 'checked'
                })(<Checkbox>{c.email2}</Checkbox>)}
              </Form.Item>
              :
              null
            }
          </Col>
        </Row>
        </React.Fragment>
      )
    }

    const ContactDriveFile = ({data}) => {
      return(
        <div style={{width: '100%', marginBottom: '8px'}}>
          <Row style={{backgroundColor: '#ECF7FA'}}>
          <Col span={23}>
          <img
            style={{
              marginLeft: "5px",
              position: "relative",
            }}
            src={data.iconLink}
            alt={data.name}
          />
          &nbsp;
          {data.name}
          </Col>
          <Col span={1}>
            <div style={flexCenterRight}>
              <Icon
                onClick={() => {
                  setContactDocList(contactDocList.filter(i => i.id !== data.id))
                }}
                style={{
                  cursor: "pointer",
                  marginTop: "4px",
                  marginRight: "5px",
                  position: "relative",
                }}
                type="delete" />
            </div>
          </Col>
          </Row>
        </div>
      )
    }

    const renderEmailPanel = () => {
      return(
      <React.Fragment>
      <Form.Item hidden={true}>
        {getFieldDecorator('submitType', {
          initialValue: "email"
        })(
          <Input disabled={true} />
        )}
      </Form.Item>
      <EmailCheckboxs />
      <Row>
        <Col span={10}>
         <Form.Item {...{
           labelCol: { span: 6 },
           wrapperCol: { span: 18 },
           }} label="CC">
          {getFieldDecorator('contact_cc', {
          })(
            <Select
                optionFilterProp={'label'}
                mode="multiple"
                disabled={newEventLoading}
                placeholder="CC"
                style={{ width: 250 }}
            >
              {
                contact.clientContacts.map(i =>
                  <Option
                    label={`${i.firstname} ${i.lastname}`}
                    value={i.id}
                    key={i.id}>
                    {`${i.firstname} ${i.lastname}`}
                  </Option>
                )
              }
            </Select>
          )}
          </Form.Item>
        </Col>

        <Col span={1} />

        <Col span={10}>
          <Form.Item {...{
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            }} label="BCC">
            {getFieldDecorator('contact_bcc', {
            })(
              <Select
                  optionFilterProp={'label'}
                  mode="multiple"
                  disabled={newEventLoading}
                  placeholder="BCC"
                  style={{ width: 250 }}
              >
              {
                contact.clientContacts.map(i =>
                  <Option
                    label={`${i.firstname} ${i.lastname}`}
                    value={i.id}
                    key={i.id}>
                    {`${i.firstname} ${i.lastname}`}
                  </Option>
                )
              }
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
         <Form.Item {...{
           labelCol: { span: 6 },
           wrapperCol: { span: 18 },
           }} label="Link Global CC">
          {getFieldDecorator('linkGlobal_cc', {
          })(
            <Select
                optionFilterProp={'label'}
                mode="multiple"
                disabled={newEventLoading}
                placeholder="Link Global CC"
                style={{ width: 250 }}
            >
              {
                linkGlobalUsers.map(i =>
                  <Option
                    label={i.name}
                    value={i.email}
                    key={i.email}>
                    {`${i.name}`}
                  </Option>
                )
              }
            </Select>
          )}
          </Form.Item>
        </Col>

        <Col span={1} />

        <Col span={10}>
          <Form.Item {...{
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            }} label="Link Global BCC">
            {getFieldDecorator('linkGlobal_bcc', {
            })(
              <Select
                  optionFilterProp={'label'}
                  mode="multiple"
                  disabled={newEventLoading}
                  placeholder="Link Global BCC"
                  style={{ width: 250 }}
              >
              {
                linkGlobalUsers.map(i =>
                  <Option
                    label={i.name}
                    value={i.email}
                    key={i.email}>
                    {`${i.name}`}
                  </Option>
                )
              }
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
          <Upload {...{
            accept: 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
            multiple: true,
            showUploadList: true,
            onRemove: file => {
              setContactAttachment(contactAttachment.filter(i => i.uid !== file.uid));
            },
            beforeUpload: (_, fileList) => {
              setContactAttachment([...contactAttachment, ...fileList])
              return false;
            },
            contactAttachment,
          }}>
            <Tooltip placement="right" title={"Allowed file: image, pdf, doc, docx, xls, xlsx, ppt, pptx"}>
              <Button disabled={newEventLoading} >
                <FontAwesomeIcon icon={faPaperclip} />&nbsp;&nbsp;Attachments
              </Button>
            </Tooltip>
          </Upload>
          <br/>
        </Col>

        <Col span={1} />

        <Col span={10}>
          <Tooltip placement="right" title={"Allowed attachment files from Google Drive"}>
            <Button onClick={() => {
              setGeneralFiles(lgFiles);
              setContactFiles(files);
              setShowContactDocs(true);
            }}
              disabled={newEventLoading || candidateFilesLoading} >
              {
                candidateFilesLoading ?
                <Icon type="loading" />
                :
                <FontAwesomeIcon icon={faFolderOpen} />
              }
              &nbsp;&nbsp;Documents
            </Button>
          </Tooltip>
          {
            contactDocList.length > 0 ?
            <div style={{marginTop: '8px', marginBottom: '22px'}}>
              {
                contactDocList.map((i, k) => (
                  <ContactDriveFile key={k} data={i} />
                ))
              }
            </div>
            :
            null
          }
        </Col>
      </Row>

      <div>
        <Form.Item>
          {getFieldDecorator('contact_email_subject', {
            rules: [{ required: true, message: 'Please input subject!' }],
          })(
            <Input autoComplete="off" placeholder="Subject" disabled={newEventLoading} />
          )}
        </Form.Item>
      </div>

      <Row>
        <Col span={24}>
          <CKEditor
            disabled={newEventLoading}
            value={contactEmailBody}
            data={contactEmailBody}
            editor={ Editor }
            config= { editorConfig }
            onChange={ ( event, editor ) => {
              const data = editor.getData();
              setContactEmailBody(data)
            }}
          />
        </Col>
      </Row>

      {
        candidateEmailDetail ?
          showEmailPanel ?
            <CandidateEmailCheckboxs />
          :
            null
        :
        null
      }

      {
        candidateEmailDetail ?
          showEmailPanel ?
            renderCandidateEmailPanel()
          :
            null
        :
        null
      }

      </React.Fragment>
      )
    }

    const handleOnSelectCandidate = async (value) => {
      if (value === "") {
        setShowEmailPanel(false);
        setCandidateEmailDetail(null);
        setCandidateFiles([]);
        setContactDocList([]);
        setCandidateDocList([]);
      }
      else{
        setContactDocList([]);
        setCandidateDocList([]);
        setCandidateFiles([]);
        setCandidateEmailDetail(value);
        const c = candidateListForNewEvent.find(i => i.id === value);
        setCandidateFilesLoading(true);
        const responseDrive = await getDrive(session.authToken, c.driveFolderID);
        setCandidateFiles(responseDrive.data.data);
        setCandidateFilesLoading(false);
      }
    }
    
    return(
      <Modal
        zIndex={100}
        centered={true}
        title="Create New Event"
        closable={false}
        visible={showCreateEventModal}
        width="90%"
        footer={[
          <Button disabled={newEventLoading} key="cancel" onClick={() => {
            setShowCreateEventModal(false);
          }}>
            <Icon type="close" />
            Cancel
          </Button>,
          <Button key="create" type="primary" onClick={handleOnClickSubmitNewEvent}>
            {newEventLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Submit
          </Button>
        ]}
      >
        <React.Fragment>

        <Modal
          centered={true}
          title="Select Contact Documents"
          closable={false}
          visible={showContactDocs}
          width={800}
          footer={[
            <Button key="cancel" onClick={() => {
              setShowContactDocs(false);
              setTimeout(() => {
                setGeneralFiles([]);
                setContactFiles([]);
                setContactDocSearch("");
              }, 250);
            }}>
              <Icon type="close" />
              Close
            </Button>
          ]}
        >
          <div style={{maxHeight: "415px"}}>
            <div>
              <Search
                value={contactDocSearch}
                placeholder="Search"
                onChange={e => setContactDocSearch(e.target.value)}
                style={{ width: 200 }}
              />
            </div>

            <br/>

            <List
              style={{
                maxHeight: "300px",
                overflow: "auto"
              }}
              size="small"
              pagination={false}
              bordered
              dataSource={
                contactDocSearch === '' ?
                [...generalFiles, ...contactFiles, ...candidateFiles]
                :
                [...generalFiles, ...contactFiles, ...candidateFiles].filter(i => i.name.toLowerCase().includes(contactDocSearch.toLowerCase()))
              }
              renderItem={(item) => (
                <List.Item>
                  <div style={{width: '100%'}}>
                  <Row>
                    {
                      [...generalFiles, ...contactFiles, ...candidateFiles].filter(i => i.starred).length > 0 ?
                      <Col span={1}>
                      {
                        item.starred ?
                        <FontAwesomeIcon style={{color: "red"}} icon={faStar} />
                        :
                        null
                      }
                      </Col>
                      :
                      null
                    }
                    <Col span={[...generalFiles, ...contactFiles, ...candidateFiles].filter(i => i.starred).length > 0 ? 18 : 19}>
                    <div>
                      <img
                        src={item.iconLink}
                        alt={item.name}
                      />
                      &nbsp;
                      {item.name}
                    </div>
                    </Col>
                    <Col span={4}>
                      {
                        item.parents[0] === process.env.REACT_APP_LG_DRIVE ? (
                          <center><Tag>Link Global Folder</Tag></center>
                        ) : null
                      }
                    </Col>
                    <Col span={1}>
                      <div style={flexCenterRight}>
                        {
                          contactDocList.find(i => i.id === item.id) ?
                          <Checkbox checked={true} onClick={() => {
                            setContactDocList(
                              contactDocList.filter(i => i.id !== item.id)
                            )
                          }}/>
                          :
                          <Checkbox checked={false} onClick={() => {
                            setContactDocList([...contactDocList, ...[item]])
                          }}/>
                        }
                      </div>
                    </Col>
                  </Row>
                  </div>
                </List.Item>
              )}
            />
          </div>
        </Modal>

        <Modal
          centered={true}
          title="Select Candidate Documents"
          closable={false}
          visible={showCandidateDocs}
          width={800}
          footer={[
            <Button key="cancel" onClick={() => {
              setShowCandidateDocs(false);
              setCandidateDocSearch("");
            }}>
              <Icon type="close" />
              Close
            </Button>
          ]}
        >
          <div style={{maxHeight: "415px"}}>
            <div>
              <Search
                value={candidateDocSearch}
                placeholder="Search"
                onChange={e => setCandidateDocSearch(e.target.value)}
                style={{ width: 200 }}
              />
            </div>

            <br/>

            <List
              style={{
                maxHeight: "300px",
                overflow: "auto"
              }}
              size="small"
              pagination={false}
              bordered
              dataSource={
                candidateDocSearch === '' ?
                [...lgFiles, ...files, ...candidateFiles]
                :
                [...lgFiles, ...files, ...candidateFiles].filter(i => i.name.toLowerCase().includes(candidateDocSearch.toLowerCase()))
              }
              renderItem={(item) => (
                <List.Item>
                  <div style={{width: '100%'}}>
                  <Row>
                    {
                      [...lgFiles, ...files, ...candidateFiles].filter(i => i.starred).length > 0 ?
                      <Col span={1}>
                      {
                        item.starred ?
                        <FontAwesomeIcon style={{color: "red"}} icon={faStar} />
                        :
                        null
                      }
                      </Col>
                      :
                      null
                    }
                    <Col span={[...lgFiles, ...files, ...candidateFiles].filter(i => i.starred).length > 0 ? 18 : 19}>
                    <div>
                      <img
                        src={item.iconLink}
                        alt={item.name}
                      />
                      &nbsp;
                      {item.name}
                    </div>
                    </Col>
                    <Col span={4}>
                      {
                        item.parents[0] === process.env.REACT_APP_LG_DRIVE ? (
                          <center><Tag>Link Global Folder</Tag></center>
                        ) : null
                      }
                    </Col>
                    <Col span={1}>
                      <div style={flexCenterRight}>
                        {
                          candidateDocList.find(i => i.id === item.id) ?
                          <Checkbox checked={true} onClick={() => {
                            setCandidateDocList(
                              candidateDocList.filter(i => i.id !== item.id)
                            )
                          }}/>
                          :
                          <Checkbox checked={false} onClick={() => {
                            setCandidateDocList([...candidateDocList, ...[item]])
                          }}/>
                        }
                      </div>
                    </Col>
                  </Row>
                  </div>
                </List.Item>
              )}
            />
          </div>
        </Modal>

        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayoutForNewEvent} label="Event Type">
            {getFieldDecorator('eventtype', {
              rules: [{ required: true, message: 'Please select event type!' }],
            })(
              <Select
                  disabled={newEventLoading}
                  placeholder="Event Type"
                  style={{ width: 220 }}
              >
              {eventTypeSelectionForNewEvent}
              </Select>
            )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayoutForNewEvent} label="Candidate">
              {getFieldDecorator('candidate', {
                initialValue: '',
              })(
                <Select
                  onChange={(value) => {handleOnSelectCandidate(value)}}
                  optionFilterProp={'label'}
                  showSearch={true}
                  disabled={newEventLoading}
                  placeholder="Candidate"
                  style={{ width: 200 }}
                >
                  {candidateSelectionForNewEvent}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{marginBottom: '10px'}}>
              <Radio.Group onChange={(e) => {
                if (e.target.value === 'email') {
                  setEventBody(null)
                }
                if (e.target.value === 'record') {
                  setCandidateDocList([])
                  setContactDocList([])
                  setContactAttachment([])
                  setCandidateAttachment([])
                  setContactEmailBody(null)
                  setCandidateEmailBody(null)
                }
                setWritingPanel(e.target.value)
                }} value={writingPanel}>
                <Radio value={"record"}>Record</Radio>
                <Radio value={"email"}>Email</Radio>
              </Radio.Group>
            </div>
          </Col>

          <Col span={12}>
            {
              writingPanel === "email" && candidateEmailDetail !== null ?
              <div>
                <Switch defaultChecked={showEmailPanel} onChange={() => {
                  setShowEmailPanel(!showEmailPanel);
                }}/>
                &nbsp;<i style={{color: "#bbb"}}>want to send email to candidate?</i>
              </div>
              :
              null
            }
          </Col>
        </Row>

        {
          writingPanel === 'record' ?
          <React.Fragment>
          <Form.Item hidden={true}>
            {getFieldDecorator('submitType', {
              initialValue: "record"
            })(
              <Input autoComplete="off" disabled={true} />
            )}
          </Form.Item>
          <Row>
            <Col span={24}>
              <CKEditor
                disabled={newEventLoading}
                value={eventBody}
                data={eventBody}
                editor={ Editor }
                config= { editorConfig }
                onChange={ ( event, editor ) => {
                  const data = editor.getData();
                  setEventBody(data);
                }}
              />
            </Col>
          </Row>
          </React.Fragment>
          :
          renderEmailPanel()
        }
        </React.Fragment>
      </Modal>
    )
  }

  const NewEventForm = Form.create({ name: 'new-event' })(NewEvent);

  const EditContact = ({form}) => {
    const { getFieldDecorator } = form;

    const [editLoading, setEditLoading] = useState(false);

    const handleSubmit = async e => {
      e.preventDefault();
      const formResult = await form.validateFields();
      setEditLoading(true);
      const result = await editContact(session.authToken, {
        ...formResult,
        ...{firstname: formResult.firstname.trim(), lastname: formResult.lastname.trim()},
        ...{id: contact.id},
      });
      setEditLoading(false);

      if (result.data.responseCode === 0) {
        dispatch({type: "INIT_CONTACT", payload: {
          ...formResult,
          ...{
            id: contact.id,
            avatar: contact.avatar,
            clientAvatar: contact.clientAvatar,
            client: contact.client,
            notes: contact.notes,
            events: contact.events,
            clientContacts: contact.clientContacts
          }
        }});
        message.success(result.data.message);
      }
      else {
        dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
      }
    };

    return(
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label="Salutation">
              {getFieldDecorator('salutation', {
                initialValue: contact.salutation,
              })(
                <Select
                  disabled={editLoading}
                  placeholder="Salutation"
                >
                  <Option value="Mr">Mr</Option>
                  <Option value="Ms">Ms</Option>
                </Select>
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="First Name">
              {getFieldDecorator('firstname', {
                initialValue: contact.firstname,
                rules: [{ required: true, message: 'Please input firstname!' }],
              })(
                <Input autoComplete="off" placeholder="First Name" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Last Name">
              {getFieldDecorator('lastname', {
                initialValue: contact.lastname,
                rules: [{ required: true, message: 'Please input lastname!' }],
              })(
                <Input autoComplete="off" placeholder="Last Name" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Birthday">
              {getFieldDecorator('dob', {
                initialValue: contact.dob ? moment(contact.dob) : null,
              })(
                <DatePicker placeholder="Date of Birth" style={{width: "100%"}} disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Email">
              {getFieldDecorator('email', {
                initialValue: contact.email,
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  },
                  {
                    required: true,
                    message: "Please input email!"
                  }
                ]
              })(
                <Input autoComplete="off" placeholder="Email" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Optional Email 1">
              {getFieldDecorator('email1', {
                initialValue: contact.email1,
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  }
                ]
              })(
                <Input autoComplete="off" placeholder="Optional Email 1" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Optional Email 2">
              {getFieldDecorator('email2', {
                initialValue: contact.email2,
                rules: [
                  {
                    type: "email",
                    message: "Please input valid email!",
                  }
                ]
              })(
                <Input autoComplete="off" placeholder="Optional Email 2" disabled={editLoading} />
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="Is Candidate">
              {getFieldDecorator('bothSide', {
                initialValue: contact.bothSide,
                valuePropName: 'checked'
              })(<Checkbox>{contact.bothSide}</Checkbox>)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...formItemLayout} label="Mobile">
              {getFieldDecorator('mobile', {
                initialValue: contact.mobile
              })(
                <Input autoComplete="off" placeholder="Mobile" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Landline">
              {getFieldDecorator('tel', {
                initialValue: contact.tel
              })(
                <Input autoComplete="off" placeholder="Landline" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Department">
              {getFieldDecorator('department', {
                initialValue: contact.department
              })(
                <Input autoComplete="off" placeholder="Department" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Position">
              {getFieldDecorator('position', {
                initialValue: contact.position
              })(
                <Input autoComplete="off" placeholder="Position" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="LinkedIn">
              {getFieldDecorator('linkedin', {
                initialValue: contact.linkedin
              })(
                <Input autoComplete="off" placeholder="Linkedin" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Wechat">
              {getFieldDecorator('wechat', {
                initialValue: contact.wechat
              })(
                <Input autoComplete="off" placeholder="Wechat" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Whats app">
              {getFieldDecorator('whatsapp', {
                initialValue: contact.whatsapp
              })(
                <Input autoComplete="off" placeholder="Whats app" disabled={editLoading} />
              )}
            </Form.Item>

            <Form.Item {...formItemLayout} label="Other Contact">
              {getFieldDecorator('othercontact', {
                initialValue: contact.othercontact
              })(
                <Input autoComplete="off" placeholder="Other Contact" disabled={editLoading} />
              )}
            </Form.Item>
          </Col>
        </Row>

        <div style={flexCenterRight}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {editLoading ? <Icon type="loading" /> : <Icon type="check" />}
              Submit
            </Button>
          </Form.Item>
        </div>

      </Form>
    )
  }

  const EditContactForm = Form.create({ name: 'edit-contact' })(EditContact);

  const cardTitle = (contact) => {
    return(
      <center>
        {
          !avatarLoading ?
          <CustomAvatar
            colourCode={contact.firstname.charAt(0).toLowerCase()}
            char={`${contact.firstname.charAt(0).toUpperCase()}${contact.lastname.charAt(0).toUpperCase()}`}
            charSize={30}
            size={86}
            src={contact.avatar}
          />
          :
          <Avatar size={86} style={{backgroundColor: '#eeeeee'}}>
              <Spin indicator={<Icon type="loading" style={{fontSize: 24}} />} />
          </Avatar>
        }
        <>
        <div style={{marginTop: "15px"}}>
          <p style={nameStyle}>
            {contact.salutation} {contact.firstname} {contact.lastname}
          </p>

          <p style={roleStyle} onClick={() => {
            navigate(`/clients/${contact.client.id}`);
          }}>
            <span style={{cursor: "pointer"}}>{contact.client.name}</span>
          </p>

          {
            contact.linkedin && contact.linkedin !== "" ?
            <React.Fragment>
            <br/>
            <p style={roleStyle} onClick={() => {
              window.open(contact.linkedin, '_blank');
            }}>
              <span style={{cursor: "pointer"}}>go to linkedin</span>
            </p>
            </React.Fragment>
            :
            null
          }
          
          {
            contact.bothSide ? (
              <React.Fragment>
                <p>
                <center>
                  <Tooltip title="This contact is candidate as well">
                    <Tag color="#0D98BA">Candidate</Tag>
                  </Tooltip>
                </center>
                </p>
              </React.Fragment>
            ) : null
          }

          <Upload
            beforeUpload={(file) => {
              return uploadFileValidator(message, file, ['image/jpeg'], 4);
            }}
            showUploadList={false}
            customRequest={(e) => {
            setAvatarLoading(true);
            var reader  = new FileReader();
            reader.readAsDataURL(e.file);

            reader.onload = function() {
              const imageData = reader.result.replace("data:image/jpeg;base64,", "")
              uploadFile(session.authToken,
                {file: imageData, name: `avatar/contact/${contact.id}.jpeg`, acl: 'public-read'}).then(x => {
                  setAvatarLoading(false);
                  e.onSuccess();
                  dispatch({type: "UPDATE_CONTACT_AVATAR"});
              })
            }
          }}>
            <Button size="small">
              {avatarLoading ? <Icon type="loading" /> : <Icon type="upload" />}Upload Avatar
            </Button>
          </Upload>

        </div>
        </>
      </center>
    )
  }

  useEffect(() => {
    async function fetchData() {
      const response = await getContact(session.authToken, props.id);

      if (response.data.responseCode === 0) {
        dispatch({type: "CLEAR_CONTACT"});
        dispatch({type: "SET_CONTACT_CANDIDATES_LIST_SELECTION", payload: 'all'});
        setNotes(response.data.contact.notes);
        dispatch({type: "INIT_CONTACT", payload: response.data.contact});

        const dataResponse = await Promise.all([
          getDrive(session.authToken, response.data.contact.client.driveFolderID),
          getDrive(session.authToken, process.env.REACT_APP_LG_DRIVE),
          getCandidates(session.authToken)
        ]);

        //construct all available candidates from events
        const allCandidates = uniqBy(response.data.contact.events.filter(i => i.candidate).map(x => x.candidate), 'id');
        dispatch({
          type: "SET_CONTACT_CANDIDATES_LIST",
          payload: allCandidates.map(i => {
            return {
              ...i,
              ...{avatar: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.id}.jpeg`}
            }
          })
        });

        setFiles(dataResponse[0].data.data);
        setLgFiles(dataResponse[1].data.data);
        //fetch all candidates from system and used in create new event candidate selection
        setCandidateListForNewEvent(dataResponse[2].data.candidates);
      
        setLoading(false);
      }
      else {
        navigate(`/contacts`);
        message.error(response.data.message);
      }

    }
    dispatch({type: "SET_INDEX", payload: "4"});
    fetchData();
  // eslint-disable-next-line
  }, []);

  const eventTypeSelection = [];
  for (let i = 0; i < eventsTypeArr.length; i++) {
    eventTypeSelection.push(
      <Option key={eventsTypeArr[i].name} value={eventsTypeArr[i].name}>
        {eventsTypeArr[i].text}
      </Option>
    )
  }

  const candidateSelection = [
    <Option key={'all'} value={'all'}>All</Option>,
    <Option key={'no-candidate'} value={'no-candidate'}>No Candidate</Option>
  ];
  for (let i = 0; i < contactCandidateList.candidates.length; i++) {
    candidateSelection.push(
      <Option key={contactCandidateList.candidates[i].id} value={contactCandidateList.candidates[i].id}>
        <CustomAvatar
          colourCode={contactCandidateList.candidates[i].firstname.charAt(0).toLowerCase()}
          char={`${contactCandidateList.candidates[i].firstname.charAt(0).toUpperCase()}${contactCandidateList.candidates[i].lastname.charAt(0).toUpperCase()}`}
          charSize={11}
          size={26}
          src={contactCandidateList.candidates[i].avatar}
        />
        &nbsp;&nbsp;{contactCandidateList.candidates[i].firstname} {contactCandidateList.candidates[i].lastname}
      </Option>
  )}

  const getEventsList = (eventType, candidate, data) => {
    let events = data;

    if (eventType !== "all" && candidate !== 'all' && candidate !== 'no-candidate') {
      events = data.filter(i => i.type === eventType && i.candidate && i.candidate.id === candidate)
    }

    if (eventType !== "all" && candidate !== 'all' && candidate === 'no-candidate') {
      events = data.filter(i => i.type === eventType && !i.candidate)
    }

    if (eventType !== "all" && candidate === 'all' && candidate === 'no-candidate') {
      events = data.filter(i => i.type === eventType)
    }

    if (eventType === "all" && candidate !== 'all' && candidate !== 'no-candidate') {
      events = data.filter(i => i.candidate && i.candidate.id === candidate)
    }

    if (eventType === "all" && candidate !== 'all' && candidate === 'no-candidate') {
      events = data.filter(i => !i.candidate)
    }

    if (eventType !== "all" && candidate === 'all' && candidate !== 'no-candidate') {
      events = data.filter(i => i.type === eventType)
    }

    return events
  }

  return (
    !contact || loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <div>
      <NewVacancyForm />
      <BackTop />
      <NewEventForm />
      <Modal
        zIndex={100}
        centered={true}
        title="Edit Contact Notes"
        closable={false}
        visible={showNotesModal}
        width="90%"
        footer={[
          <Button disabled={notesLoading} key="cancel" onClick={() => {
            setShowNotesModal(false);
            if (contact.notes) {
              setNotes(contact.notes);
            } else {
              setNotes("");
            }
          }}>
            <Icon type="close" />
            Cancel
          </Button>,
          <Button key="edit" type="primary" onClick={() => {
            setNotesLoading(true);
            editContactNotes(
              session.authToken,
              {id: contact.id, notes: notes}
            ).then(x => {

              if (x.data.responseCode === 0) {
                dispatch({type: "UPDATE_CONTACT_NOTES", payload: notes});
                setShowNotesModal(false);
                setNotesLoading(false);
                message.success("contact notes update successful");
              }
              else {
                setShowNotesModal(false);
                setNotesLoading(false);
                setNotes(contact.notes);
                message.error(x.data.message);
              }

            });
          }}>
            {notesLoading ? <Icon type="loading" /> : <Icon type="check" />}
            Submit
          </Button>
        ]}
      >
        <CKEditor
          disabled={notesLoading}
          value={notes}
          data={notes}
          editor={ Editor }
          config= { editorConfig }
          onChange={ ( event, editor ) => {
            const data = editor.getData();
            setNotes(data);
          }}
        />
      </Modal>
      <Row>
        <Col span={6}>
          <div style={{marginRight: '5px'}}>
            <Card title={cardTitle(contact)} bordered={true}>
              <div style={{marginTop: '-25px'}}>
                {
                  contact.dob && contact.dob !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b></div>
                    <div>{moment(contact.dob).format('YYYY-MM-DD')}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.email !== "" || contact.email1 !== "" || contact.email2 !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><Icon type="mail" theme="filled" /> <b>Email</b></div>
                    {
                      contact.email !== "" ?
                      <div>{contact.email}</div>
                      :
                      null
                    }
                    {
                      contact.email1 !== "" ?
                      <div>{contact.email1}</div>
                      :
                      null
                    }
                    {
                      contact.email2 !== "" ?
                      <div>{contact.email2}</div>
                      :
                      null
                    }
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.department && contact.department !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><FontAwesomeIcon icon={faBuilding} /> <b>Department</b></div>
                    <div>{contact.department}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.position && contact.position !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><Icon type="idcard" theme="filled" /> <b>Position</b></div>
                    <div>{contact.position}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.tel && contact.tel !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><Icon type="phone" theme="filled" /> <b>Landline</b></div>
                    <div>{contact.tel}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.mobile && contact.mobile !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><Icon type="mobile" theme="filled" /> <b>Mobile</b></div>
                    <div>{contact.mobile}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.wechat && contact.wechat !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><Icon type="wechat" theme="filled" /> <b>Wechat</b></div>
                    <div>{contact.wechat}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.whatsapp && contact.whatsapp !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><FontAwesomeIcon icon={faPhoneVolume} /> <b>Whats App</b></div>
                    <div>{contact.whatsapp}</div>
                  </React.Fragment>
                  :
                  null
                }

                {
                  contact.othercontact && contact.othercontact !== "" ?
                  <React.Fragment>
                    <br/>
                    <div><FontAwesomeIcon icon={faExclamationCircle} /> <b>Other Contact</b></div>
                    <div>{contact.othercontact}</div>
                  </React.Fragment>
                  :
                  null
                }

              </div>
            </Card>
          </div>
        </Col>

        <Col span={18}>
          <div style={{marginLeft: '5px'}}>
            <Tabs
              tabBarExtraContent={<div>
                Created By
                &nbsp;&nbsp;
                <CustomAvatar
                  colourCode={contact.register.firstname.charAt(0).toLowerCase()}
                  char={`${contact.register.firstname.charAt(0).toUpperCase()}${contact.register.lastname.charAt(0).toUpperCase()}`}
                  charSize={14}
                  size={24}
                  src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${contact.register.id}.jpeg`}
                />
                &nbsp;at&nbsp;<span>{moment(contact.createdAt).format('DD/MM/YY')}</span>
              </div>}
              onChange={() => {}} 
              type="card"
            >
              <TabPane tab={
                <span><FontAwesomeIcon icon={faClipboard} /> Notes</span>
              } key="1">
                <div style={flexCenterRight}>
                  <Button type="primary" onClick={() => {
                    setShowNotesModal(true);
                  }}><Icon type="edit" /> Edit Notes</Button>
                </div>
                <br/>
                {
                  contact.notes && contact.notes !== "" ?
                  parse(contact.notes)
                  :
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faFileInvoiceDollar} /> Invoices <Badge count={contact.invoices.length + contact.additionalInvoices.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
              } key="4">
                <InvoicesList invoices={[...contact.invoices, ...contact.additionalInvoices]} type="contact" />
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faTasks} /> Events <Badge count={contact.events.length} style={{ backgroundColor: '#B0BF1A' }} /></span>
              } key="2">
                <Row>
                  <Col span={8}>
                    <div>
                    <Select
                       value={eventType}
                       style={{ width: 220 }} onChange={(value) => {setEventType(value)}}
                    >
                    {eventTypeSelection}
                    </Select>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div>
                    <Select
                      value={contactCandidateList.candidate}
                      style={{ width: 220 }}
                      onChange={(value) =>{
                        dispatch({
                          type: "SET_CONTACT_CANDIDATES_LIST_SELECTION",
                          payload: value
                        })
                      }}>
                      {candidateSelection}
                    </Select>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={flexCenterRight}>
                      <Button type="primary" onClick={() => {
                        setShowCreateVacancyModal(true)
                      }}><Icon type="plus-square" /> New Vacancy</Button>
                      &nbsp;&nbsp;
                      <Button type="primary" onClick={() => {
                        setShowCreateEventModal(true)
                      }}><Icon type="plus-square" /> New Event</Button>
                    </div>
                  </Col>
                </Row>
                <br/>
                <Spin spinning={eventReloading} indicator={<Icon type="loading" />}>
                <ContactEventsList
                  contactID={props.id}
                  data={getEventsList(eventType, contactCandidateList.candidate, contact.events)}/>
                </Spin>
              </TabPane>
              <TabPane tab={
                <span><FontAwesomeIcon icon={faEdit} /> Edit Contact</span>
              } key="3">
                <EditContactForm />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
}
const Contact = Form.create({ name: 'contact-form' })(ContactForm);

export default Contact;
